// src/app/shared/components/whatsapp-button/whatsapp-button.component.ts
import { Component } from '@angular/core';

@Component({
  selector: 'app-whatsapp-button',
  standalone: true,
  templateUrl: './whatsapp-button.component.html',
  styleUrls: ['./whatsapp-button.component.css'],
})
export class WhatsappButtonComponent {
  phoneNumber = '5491127759760';
  defaultMessage = 'Hola! Me gustaría obtener más información sobre sus servicios.';

  get whatsappUrl(): string {
    const encodedMessage = encodeURIComponent(this.defaultMessage);
    return `https://wa.me/${this.phoneNumber}?text=${encodedMessage}`;
  }
}